import { appConfig } from "@/config/app-config";
import { recordEvent } from "@/lib/nemmp/base/tracking/usage/recordEvent";
import { MLogo } from "@/lib/nemmp/starter/app/MLogo";
import Box from "@mui/material/Box";
import { logoInfoMenuState } from "../LogoInfoMenuState";

/**
 * Top-left logo for website-layout pages. Opens `LogoInfoMenu` on click.
 */
export function WebsiteHeader() {
  return (
    <Box sx={{ px: 2, pt: 2, pb: 0.5, flexShrink: 0 }}>
      <Box
        sx={{ cursor: "pointer", display: "inline-block" }}
        aria-label="Info"
        onClick={(event) => {
          recordEvent("click-website-layout-logo");
          logoInfoMenuState.openLogoMenu(event.currentTarget);
        }}
      >
        <MLogo appConfig={appConfig} />
      </Box>
    </Box>
  );
}
